// inviteFriends.js
// This module handles clicks on the "Invite Friends" button.
// It will either use the Web Share API (if available) or copy the profile link to clipboard.

import { copyToClipboard } from './utilities.js';

export function initInviteFriends(config) {
  document.addEventListener('click', (event) => {
    const inviteBtn = event.target.closest('.invite-friends-button');
    if (inviteBtn) {
      event.preventDefault();
      handleInviteFriends(inviteBtn, config);
    }
  });
}

async function handleInviteFriends(inviteBtn, config) {
  const username = inviteBtn.getAttribute('data-username');
  if (!username) {
    window.showToast('Unable to share profile. Please try again.', 'danger');
    return;
  }
  const profileUrl = `${window.location.origin}/@${username}`;
  const shareText = `Check out my profile on r8ted: ${profileUrl}`;

  if (navigator.share) {
    try {
      await navigator.share({
        title: 'Join me on r8ted!',
        text: shareText,
        url: profileUrl,
      });
      window.showToast('Profile shared successfully!', 'success');
    } catch (err) {
      console.error('Share canceled or error:', err);
      copyToClipboard(shareText);
    }
  } else {
    copyToClipboard(shareText);
  }
}
